<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->

@if (errorWhileInitializing()) {
  <div class="profile:flex profile:min-h-50 profile:justify-center profile:items-center">
    <profile-pds-p-text p-text size="medium" align="center">{{ 'pidpaw.generic.error.initialisation' | translate }} </profile-pds-p-text>
  </div>
}

@if (!errorWhileInitializing()) {
  @if (isLoading$ | async) {
    @if (announceLoading()) {
      <span class="profile:sr-only" role="status" aria-live="polite" aria-atomic="true">
        {{ 'addressWidget.general.loadingStatus' | translate }}
      </span>
    }
    @if (mode === MyProfileAddressWidgetMode.PROFILE) {
      <pidx-skeleton-loader data-protractor-id="address-widget-app-loader"></pidx-skeleton-loader>
    }
    @if (mode === MyProfileAddressWidgetMode.CHECKOUT) {
      <div class="profile:h-[300px] profile:max-h-screen profile:flex profile:justify-center">
        <profile-pds-p-spinner
          p-spinner
          [size]="{ base: 'small', l: 'medium' }"
          [attr.aria-label]="'pidpaw.generic.aria.loading' | translate"
          data-protractor-id="address-widget-app-loader"
        ></profile-pds-p-spinner>
      </div>
    }
  } @else {
    <!-- BEGIN // PROFILE MODE -->
    @if (mode === MyProfileAddressWidgetMode.PROFILE) {
      @if ((isCnUser$ | async) && restrictGlobalUIChanges) {
        <div class="profile:mt-fluid-md profile:flex profile:flex-col profile:md:flex-row">
          <div class="profile:w-full profile:md:w-1/4 profile:md:pe-static-sm">
            <profile-pds-p-text p-text size="small" color="contrast-medium"
              >{{ 'pidp.personalData.addresses.headline' | translate }}
            </profile-pds-p-text>
          </div>
          <div class="profile:w-full profile:md:w-3/4">
            <profile-pds-p-inline-notification
              p-inline-notification
              class="profile:w-full profile:md:w-1/2 profile:mt-fluid-md profile:md:mt-0"
              [dismissButton]="false"
              description="{{ 'pidpaw.cnViewOrEditRestrictionDisclaimer.message' | translate }}"
            >
            </profile-pds-p-inline-notification>
          </div>
        </div>
      } @else {
        @if (!shouldShowHideSection()) {
          <div class="profile:mt-fluid-md profile:flex profile:flex-col profile:md:flex-row">
            <div class="profile:w-full profile:md:w-1/4 profile:md:pe-static-sm">
              <profile-pds-p-heading p-heading [tag]="'h3'" size="small" color="contrast-medium"
                >{{ 'pidpaw.editAddress.headline.primaryAddress' | translate }}
              </profile-pds-p-heading>
            </div>
            <div class="profile:w-full profile:md:w-3/4">
              @if (errorMessage$ | async; as messages) {
                <pidx-inline-form-messages [messages]="[messages | translate]"></pidx-inline-form-messages>
              }
              <myprofile-address-list
                [instanceId]="instanceId"
                [mode]="MyProfileAddressListMode.ONLY_STANDARD"
                [editItemLabel]="'pidpaw.selectAddress.button.editAddress.label' | translate"
                [deleteItemLabel]="'pidpaw.editAddress.button.delete.label' | translate"
                [emptyListLabel]="'pidpaw.selectAddress.button.emptyState.label' | translate"
                [token]="token"
              ></myprofile-address-list>
            </div>
          </div>
        }
        @if (((addresses$ | async)?.length ?? 0) > 1) {
          <div class="profile:mt-fluid-md profile:flex profile:flex-col profile:md:flex-row">
            <div class="profile:w-full profile:md:w-1/4 profile:md:pe-static-sm">
              <profile-pds-p-heading p-heading [tag]="'h3'" size="small" color="contrast-medium">
                {{ 'pidpaw.editAddress.headline.additionalAddresses' | translate }}
              </profile-pds-p-heading>
            </div>
            <div class="profile:w-full profile:md:w-3/4">
              <myprofile-address-list
                [instanceId]="instanceId"
                [mode]="MyProfileAddressListMode.ONLY_ADDITIONAL"
                [editItemLabel]="'pidpaw.selectAddress.button.editAddress.label' | translate"
                [deleteItemLabel]="'pidpaw.editAddress.button.delete.label' | translate"
                [token]="token"
              ></myprofile-address-list>
            </div>
          </div>
        }
      }
    }
    <!-- END // PROFILE MODE -->
    <!-- BEGIN // CHECKOUT MODE -->
    @if (mode === MyProfileAddressWidgetMode.CHECKOUT) {
      @if (shouldShowHeadline) {
        <profile-pds-p-heading p-heading [tag]="'h4'" weight="bold">
          {{ 'pidpaw.generic.headline.selectOrAddAddress' | translate }}
        </profile-pds-p-heading>
      }
      @if ((isCnUser$ | async) && restrictGlobalUIChanges) {
        <profile-pds-p-inline-notification
          p-inline-notification
          class="profile:w-full profile:md:w-1/2 profile:mt-fluid-md profile:md:mt-0"
          [dismissButton]="false"
          description="{{ 'pidpaw.cnViewOrEditRestrictionDisclaimer.message' | translate }}"
        >
        </profile-pds-p-inline-notification>
      } @else {
        @if (errorMessage$ | async) {
          <profile-pds-p-text p-text color="contrast-medium" data-protractor-id="address-widget-error-messages">
            {{ errorMessage$ | async | translate }}
          </profile-pds-p-text>
        }
        @if (!(errorMessage$ | async)) {
          <div>
            <myprofile-address-list-checkout
              [instanceId]="instanceId"
              [editItemLabel]="'pidpaw.selectAddress.button.editAddress.label' | translate"
              [token]="token"
              data-protractor-id="address-widget-address-list"
            ></myprofile-address-list-checkout>
          </div>
        }
      }
    }
    <!-- END // CHECKOUT MODE -->
    <!-- BEGIN // MYLANTA MODE-->
    @if (mode === MyProfileAddressWidgetMode.MYLANTA) {
      @if ((isCnUser$ | async) && restrictGlobalUIChanges) {
        <profile-pds-p-inline-notification
          p-inline-notification
          class="profile:w-full profile:md:w-1/2 profile:mt-fluid-md profile:md:mt-0"
          [dismissButton]="false"
          description="{{ 'pidpaw.cnViewOrEditRestrictionDisclaimer.message' | translate }}"
        >
        </profile-pds-p-inline-notification>
      } @else {
        @if (errorMessage$ | async) {
          <profile-pds-p-text p-text color="contrast-medium" data-protractor-id="address-widget-error-messages">
            {{ errorMessage$ | async | translate }}
          </profile-pds-p-text>
        }
        @if (!(errorMessage$ | async)) {
          <div>
            <myprofile-address-list-mylanta
              [instanceId]="instanceId"
              [editItemLabel]="'pidpaw.selectAddress.button.editAddress.label' | translate"
              [token]="token"
              data-protractor-id="address-widget-address-list"
            ></myprofile-address-list-mylanta>
          </div>
        }
      }
    }
    <!-- END // MYLANTA MODE -->
    <!-- BEGIN // Edit Address Editor -->
    @if (!(isCnUser$ | async) || ((isCnUser$ | async) && !restrictGlobalUIChanges)) {
      @if ((showEditor$ | async) && !(addressBeingEdited$ | async)) {
        <!--    Add Address in Checkout mode -->
        @if (this.mode !== MyProfileAddressWidgetMode.PROFILE) {
          <div>
            <div [class.profile:mt-fluid-md]="((addresses$ | async)?.length ?? 0) > 0">
              <myprofile-address-editform
                [mode]="mode"
                [instanceId]="instanceId"
                [token]="token"
                [cancelButtonLabel]="'pidpaw.editAddress.button.cancel.label' | translate"
                [saveButtonLabel]="'pidpaw.editAddress.button.save.label' | translate"
                [deleteButtonLabel]="'pidpaw.editAddress.button.delete.label' | translate"
                [saveAndContinueButtonLabel]="'pidpaw.editAddress.button.saveAndContinue.label' | translate"
              ></myprofile-address-editform>
            </div>
          </div>
        }
        <!--    Add Address in Profile mode -->
        @if (this.mode === MyProfileAddressWidgetMode.PROFILE) {
          <div class="profile:mt-fluid-md profile:flex profile:flex-col profile:md:flex-row">
            <div class="profile:w-full profile:md:w-1/4 profile:md:pe-static-sm">
              <profile-pds-p-text id="add-new-address-hint" p-text size="small" color="contrast-medium"
                >{{ 'pidpaw.editAddress.headline.addNewAddress' | translate }}
              </profile-pds-p-text>
            </div>
            <div class="profile:w-full profile:md:w-3/4">
              <myprofile-address-editform
                [mode]="mode"
                [instanceId]="instanceId"
                [token]="token"
                [cancelButtonLabel]="'pidpaw.editAddress.button.cancel.label' | translate"
                [saveButtonLabel]="'pidpaw.editAddress.button.save.label' | translate"
                [deleteButtonLabel]="'pidpaw.editAddress.button.delete.label' | translate"
                [saveAndContinueButtonLabel]="'pidpaw.editAddress.button.saveAndContinue.label' | translate"
              ></myprofile-address-editform>
            </div>
          </div>
        }
      } @else {
        <div
          class="profile:flex profile:flex-col profile:md:flex-row"
          [class.profile:mt-fluid-md]="this.mode !== MyProfileAddressWidgetMode.PROFILE"
        >
          @if (this.mode === MyProfileAddressWidgetMode.PROFILE) {
            <div
              class="profile:col-basic profile:grid profile:col-span-one-third profile:w-full profile:md:w-1/4 profile:md:pe-static-sm"
            ></div>
          }
          <div>
            @if (
              isAddAddressesTemplate() && ((addresses$ | async)?.length ?? 0) < MAX_ADDRESSES && mode !== MyProfileAddressWidgetMode.PROFILE
            ) {
              <profile-pds-p-button-pure
                p-button-pure
                icon="plus"
                id="addAddressBtn"
                data-protractor-id="address-widget-add-address-button"
                (click)="enterEditMode()"
                >{{ 'pidpaw.generic.button.addAddress.label' | translate }}
              </profile-pds-p-button-pure>
            }
            @if (
              isAddAddressesTemplate() && ((addresses$ | async)?.length ?? 0) < MAX_ADDRESSES && mode === MyProfileAddressWidgetMode.PROFILE
            ) {
              <profile-pds-p-button
                p-button
                class="profile:mt-fluid-md"
                variant="secondary"
                icon="plus"
                id="addAddressBtn"
                data-protractor-id="address-widget-add-address-button"
                (click)="enterEditMode()"
                [myprofileUiTrack]="{
                  clickElementType: 'button',
                  clickElementId: 'address',
                  clickElementName: 'add',
                }"
                >{{ 'pidpaw.generic.button.addAddress.label' | translate }}
              </profile-pds-p-button>
            }
            @if (isAddAddressesTemplate() && ((addresses$ | async)?.length ?? 0) >= MAX_ADDRESSES) {
              <profile-pds-p-text p-text data-protractor-id="address-widget-too-many-addresses-hint" size="small"
                >{{ 'pidpaw.generic.label.tooManyAddresses' | translate }}
              </profile-pds-p-text>
            }
          </div>
        </div>
      }
    }
    <!-- END // Edit Address Editor -->
  }
}

<!-- BEGIN // Add New Address -->
<!-- END // Add New Address -->
